import { useEffect } from 'react';
import mixpanel from 'mixpanel-browser';
import { useGetTeamPlanQuery } from '../redux/apis/app-api';
import { useSelectedTeam } from '../redux/hooks';
import mapLoadLimit from '../lib/map-load-limit';
import usageProfile from '../lib/usage-profile';

// 選択中のチームの地図表示回数を、Mixpanel のプロフィール属性として送る。
//
// 無料枠に対する消費率（mapLoadRatio）を持たせるのが目的。利用者を消費率で
// 分布させれば、無料枠に収まっているのか、溢れているのに課金していないのかを
// 見分けられる。どちらかで打つ手が変わる。
//
// useGetTeamPlanQuery は useSelectedTeam が既に呼んでいる。RTK Query の
// キャッシュを共有するので、ここで呼んでも API のリクエストは増えない。
export const useReportTeamUsage = (): void => {
  const { selectedTeam } = useSelectedTeam();
  const teamId = selectedTeam?.teamId;

  // currentData を使う。data は「引数に関係なく直近に返ってきた結果」なので、
  // チームを切り替えた直後は前のチームの結果が入っている。それを使うと、
  // 新しいチームの teamId に前のチームの利用量を載せて送ってしまう。
  const { currentData: planDetails } = useGetTeamPlanQuery(
    { teamId: teamId || '' },
    { skip: !teamId },
  );

  useEffect(() => {
    if (!selectedTeam || !planDetails) return;

    const profile = usageProfile({
      count: planDetails.usage?.count,
      limit: mapLoadLimit({
        hasSubscription: Boolean(planDetails.subscription),
        baseFreeMapLoadCount: selectedTeam.baseFreeMapLoadCount,
        customMaxMapLoadCount: selectedTeam.customMaxMapLoadCount,
      }),
      planId: planDetails.planId,
      teamId: selectedTeam.teamId,
    });

    if (!profile) return;

    mixpanel.people.set(profile);
  }, [selectedTeam, planDetails]);
};

export default useReportTeamUsage;
